import { post } from './require'

const wlzsApi = {
  AddCooperationCommonMessage: (params) => post('/api/v2/Management/AddCooperationCommonMessage', params, 'baseapi')
}

export default wlzsApi
